import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { UserState } from '@app/auth/user.state';
import { ProjectState } from '@app/projects/project.state';
import { HELP_DOCS_URL } from '@app/shared/help-docs-links.constants';
import { VersionService } from '@app/shared/version.service';

import { environment } from '../../environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgbTooltipModule],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  private readonly userState = inject(UserState);
  private readonly versionService = inject(VersionService);
  protected readonly projectId = inject(ProjectState).projectId;

  protected readonly WHATS_NEW = HELP_DOCS_URL.WHATS_NEW;

  protected readonly name = environment.name;
  protected readonly version = this.versionService.currentVersion;
  protected readonly year = new Date().getFullYear();

  protected readonly org = this.userState.org;
  protected readonly multipleOrgs = computed(() => this.userState.orgs().length > 1);
}
